<template>
  <div class="bg-white p-4">
    <!-- <task-detail @onSave="refreshStages" @onDelete="refreshStages" /> -->
    <task-detail />

    <b-row>
      <b-col md="7" offset-md="2">
        <h1 class="title text-center mb-4">{{ $t("roadmap.platform.text") }}</h1>
      </b-col>
    </b-row>
    <!---->

    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="PLATFORM_ROADMAP" definition="SYSTEM_AND_ROADMAP_TUTORIAL" :title="$t('roadmap.stage.system-and-roadmap-tutorial')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="PLATFORM_ROADMAP" definition="ORGANIZATION_DETAIL" :title="$t('roadmap.stage.organization-detail')" :lines="['left', 'right']" />
        <div class="line left"></div>
        <div class="line right"></div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="5" class="position-relative">
        <Stage roadmapDefinition="PLATFORM_ROADMAP" definition="ORGANIZATION_HIERARCHY" :title="$t('roadmap.stage.organization-hierarchy')" />
      </b-col>
      <b-col md="5" offset-md="1" class="position-relative">
        <Stage roadmapDefinition="PLATFORM_ROADMAP" definition="THIRD_PARTY" :title="$t('roadmap.stage.third-party')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="5" class="position-relative">
        <Stage roadmapDefinition="PLATFORM_ROADMAP" definition="PLATFORM_POLICY" :title="$t('roadmap.stage.platform-policy')" />
      </b-col>
    </b-row>

    <!---->
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import Stage from "./component/roadmap-stage";

export default {
  components: { Stage },

  mounted() {
    const stages = ["SYSTEM_AND_ROADMAP_TUTORIAL", "ORGANIZATION_DETAIL", "ORGANIZATION_HIERARCHY", "THIRD_PARTY", "PLATFORM_POLICY"];
    EventBus.$on("task-board-update", (e) => {
      stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
    EventBus.$on("roadmap-stage-updated", (e) => {
      e.stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
  },
  methods: {
    // refreshStages(item) {
    //   setTimeout(() => {
    //     const stage = item?.relations?.roadmapStage;
    //     if (stage?.roadmapDefinition == "PLATFORM_ROADMAP") {
    //       this.loadStage(stage?.definition);
    //       stage.next.forEach((s) => this.loadStage(s));
    //     }
    //   }, 4000);
    // },
    async loadStage(stage) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`organizationRoadmap/loadStage`, { roadmap: "PLATFORM_ROADMAP", stage });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./roadmap";
</style>
